module.exports = __webpack_public_path__ + "static/media/pin_carglass_highlighted.8b2c2d6d.png";